import React, { useState, useEffect } from "react";
import ReusableProgessBar from "components/common/ReusableProgessBar";
import Navbar from "./Navbar";
import DirectionLine from "./DirectionLine";
import { useDispatch, useSelector } from "react-redux";
import { goBack } from "../../../../../src/redux/slice/onboardingFormSlice";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import { submitAllFormData } from "../../../../../src/redux/formApiActions";
import { toast, ToastContainer } from "react-toastify";
import useUploadPreOnboardingDocs from "../../../../../src/hooks/useUploadPreOnboardingDocs";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import { useForm } from "react-hook-form";
import ValidateFile from "../../../../utils/ValidateFile";

export default function AdditionalDetailsForm() {
  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors, isSubmitted }, watch, setValue } = useForm({
    mode: "onChange"
  });
  const { getInvitedUserDetailsById } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );
  const {
    additionalDetails,
    professionalReferences,
  } = getInvitedUserDetailsById ?? {};
  const savedData = additionalDetails;
  const profRefsavedData = professionalReferences;
  const [checked, setChecked] = useState(!!savedData?.passportNumber);
  const [showPassportDetails, setShowPassportDetails] = useState(
    savedData?.havePassport === "Yes",
  );
  const [docError, setDocError] = useState({
    passportFrontError: false,
    passportbackError: false,
    illnessError: false,
  });
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;

  const doc = useSelector((state) => state.getPreOnboardingDocsById.docs);

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);

  const { handleFileUpload } = useUploadPreOnboardingDocs();


  const moptraRelative = watch("moptraRelative", "");
  const illness = watch("illness", "");

  const handleFormSubmit = (data) => {
    if (
      (!doc.passportFrontImage && showPassportDetails) ||
      (!doc.passportLastPageImage && showPassportDetails) ||
      (!doc.illnessDocument && data.illness === "yes")
    ) {
      setDocError({
        passportFrontError: showPassportDetails
          ? !doc.passportFrontImage
          : false,
        passportbackError: showPassportDetails
          ? !doc.passportLastPageImage
          : false,
        illnessError: illness ? !doc.illnessDocument : false,
      });
      toast.error("Please upload all required documents before submitting.", {
        className: "toast-error-custom",
        autoClose: 4000,
      });
      return;
    }

    const AdditionalDetailsPayload = {
      havePassport: checked ? "Yes" : "No",
      passportNumber: checked ? data.passport : "",
      illness: data.illness,
      illnessDeclaration: data.illness === "yes" ? data.anyIllnessDetail : "",
      hobbiesDeclaration: data.hobbies,
    };

    const professionalDetailspayload = [
      {
        name: data.moptraRelative === "yes" ? data.moptraRelativeName : "",
        designation:
          data.moptraRelative === "yes" ? data.moptraRelativeDesg : "",
        relationship:
          data.moptraRelative === "yes" ? data.moptraRelativeRelationship : "",
        employeeId:
          data.moptraRelative === "yes" ? data.moptraRelativeEmpId : "",
        department:
          data.moptraRelative === "yes" ? data.moptraRelativeDept : "",
        isRelative: data.moptraRelative === "yes",
      },
    ];
    const finalPayload = {
      professionalReferences: professionalDetailspayload,
      additionalDetails: AdditionalDetailsPayload,
      type: "FULL_UPDATE",
      status: "PARTIAL_COMPLETED",
    };
    dispatch(submitAllFormData(finalPayload, paramId, "saveandnext"));
  };

  useEffect(() => {
    setShowPassportDetails(!!savedData?.passportNumber);

    setValue("passport", savedData?.passportNumber ?? "");
    setValue(
      "Passportchecked",
      savedData?.passportNumber ? "yes" : "no",
    );
    setValue("illness", savedData?.illnessDeclaration ? "yes" : "no");
    setValue("anyIllnessDetail", savedData?.illnessDeclaration ?? "");
    setValue("hobbies", savedData?.hobbiesDeclaration ?? "");

    setValue("moptraRelativeName", profRefsavedData?.[0]?.name || "");
    setValue("moptraRelativeDesg", profRefsavedData?.[0]?.designation || "");
    setValue(
      "moptraRelativeRelationship",
      profRefsavedData?.[0]?.relationship || "",
    );
    setValue("moptraRelativeEmpId", profRefsavedData?.[0]?.employeeId || "");
    setValue("moptraRelativeDept", profRefsavedData?.[0]?.department || "");
    setValue(
      "moptraRelative",
      profRefsavedData?.[0]?.isRelative ? "yes" : "no",
    );

  }, [savedData, setValue, profRefsavedData]);

  const handleSaveAsDraft = () => {
    try {
      const data = watch();
      const AdditionalDetailsPayload = {
        havePassport: checked ? "Yes" : "No",
        passportNumber: checked ? data.passport : "",
        illness: data.illness,
        illnessDeclaration: data.illness === "yes" ? data.anyIllnessDetail : "",
        hobbiesDeclaration: data.hobbies,
      };

      const professionalDetailspayload = [
        {
          name: data.moptraRelative === "yes" ? data.moptraRelativeName : "",
          designation:
            data.moptraRelative === "yes" ? data.moptraRelativeDesg : "",
          relationship:
            data.moptraRelative === "yes"
              ? data.moptraRelativeRelationship
              : "",
          employeeId:
            data.moptraRelative === "yes" ? data.moptraRelativeEmpId : "",
          department:
            data.moptraRelative === "yes" ? data.moptraRelativeDept : "",
          isRelative: data.moptraRelative === "yes",
        },
      ];

      const finalPayload = {
        professionalReferences: professionalDetailspayload,
        additionalDetails: AdditionalDetailsPayload,
        type: "PARTIAL_UPDATE",
        status: "DRAFT",
      };
      dispatch(submitAllFormData(finalPayload, paramId, "draft"));
    } catch (error) {
      toast.error("Failed to save draft. Please try again.", {
        className: "toast-error-custom",
        autoClose: 4000,
      });
      throw (error)
    }
  };

  const handlePassportFileChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const validate = ValidateFile(file, allowedTypes)

    if (validate !== true) {
      toast.error(validate);
      return;
    }

    await handleFileUpload(file, type, paramId);
    dispatch(
      fetchgetPreOnboardingDocsById({
        type,
        id: paramId,
      }),
    )
    setDocError({
      passportFrontError: !doc.passportFrontImage,
      passportbackError: !doc.passportLastPageImage,
      illnessError: !doc.illnessDocument,
    });
  };

  const handleIllnessFileChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const validate = ValidateFile(file, allowedTypes)

    if (validate !== true) {
      toast.error(validate);
      return;
    }

    await handleFileUpload(file, type, paramId);
    dispatch(
      fetchgetPreOnboardingDocsById({
        type,
        id: paramId,
      }),
    )
    setDocError({
      passportFrontError: !doc.passportFrontImage,
      passportbackError: !doc.passportLastPageImage,
      illnessError: !doc.illnessDocument,
    });
  };

  useEffect(() => {
    dispatch(
      fetchgetPreOnboardingDocsById({
        type: "passportFrontImage",
        id: paramId,
      }),
    );
    dispatch(
      fetchgetPreOnboardingDocsById({
        type: "passportLastPageImage",
        id: paramId,
      }),
    );
    dispatch(
      fetchgetPreOnboardingDocsById({ type: "illnessDocument", id: paramId }),
    );
  }, []);
  useEffect(() => {
    setDocError({
      passportFrontError: !doc.passportFrontImage,
      passportbackError: !doc.passportLastPageImage,
      illnessError: !doc.illnessDocument,
    });
  }, [doc]);

  return (
    <div className="wrapper">
      <Navbar />
      <div className="sidebar">
        <div className="sidebar-wrapper">
          <ReusableProgessBar />
        </div>
      </div>
      <div className="main-panel">
        <div className="form-content">
          <div className="container-fluid form-navbar">
            <div className="personaldetail-form">
              <DirectionLine />
              <div className="personalDetailForm">
                <form onSubmit={handleSubmit(handleFormSubmit)} className="edu-form-container additional-details" >
                  <div className="personalDetailHeading">
                    <h6 className="educationalHeadline">PASSPORT DETAILS</h6>
                  </div>

                  <div className="form-group col-md-6">
                    <div className="passport-details">
                      <label htmlFor="passport">
                        Do you have a Passport?
                      </label>
                      <div className="checkbox-wrapper-25">
                        <input
                          id="passport"
                          type="checkbox"
                          checked={showPassportDetails}
                          {...register("Passportchecked")}
                          onChange={() => {
                            setShowPassportDetails(!showPassportDetails);
                            setChecked(!checked);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {showPassportDetails && (<>
                    <div className="passportDetailsContainer col-md-12">

                      <div className="form-group col-md-4">
                        <label htmlFor="passportNo">Passport No.</label>
                        <div className="flex-grow-1"></div>
                        <input
                          id="passportNo"
                          type="text"
                          placeholder="Passport Number"
                          maxLength={20}
                          className={`form-control ${errors.passport ? "border-red-500" : ""
                            }`}
                          {...register("passport", {
                            required: "Passport Number is required",
                            pattern: {
                              value: /^[A-Z0-9]{5,20}$/i,
                              message: "Invalid passport number format",
                            },
                          })}
                        />
                        {errors.passport && (
                          <p className="errorMessage">
                            {errors.passport.message}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="passportFrontImage">Passport Front Image</label>
                        <input
                          id="passportFrontImage"
                          type="file"
                          accept="image/*"
                          className={`form-control ${errors.passportFrontImage ? "border-red-500" : ""
                            }`}
                          {...register("passportFrontImage", {
                            // required: "Passport front image is required",
                            onChange: (e) =>
                              handlePassportFileChange(
                                e,
                                "passportFrontImage",
                              ),
                          })}
                        />
                        {doc.passportFrontImage && (
                          <img className="passport-img"
                            src={doc.passportFrontImage}
                            alt="preview" />
                        )}
                        {isSubmitted && docError.passportFrontError && (
                          <p className="errorMessage">
                            Passport front image is required
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="passportLastPageImage">Passport Last Page Image</label>
                        <input
                          id="passportLastPageImage"
                          type="file"
                          accept="image/*"
                          className={`form-control ${errors.passportLastPageImage
                            ? "border-red-500"
                            : ""
                            }`}
                          {...register("passportLastPageImage", {
                            // required: "Passport last page image is required",
                            onChange: (e) =>
                              handlePassportFileChange(
                                e,
                                "passportLastPageImage",
                              ),
                          })}
                        />
                        {doc?.passportLastPageImage && (
                          <img className="passport-img"
                            src={doc?.passportLastPageImage}
                            alt="preview" />
                        )}
                        {isSubmitted && docError.passportbackError && (
                          <p className="errorMessage">
                            Passport last page image is required
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <small className="help-text"><strong>Accepted Formats:</strong> PDF, JPG, JPEG, and PNG only.| Size: 5MB</small>
                    </div>
                  </>)}
                  <div className="personalDetailHeading">
                    <h6 className="educationalHeadline">OTHER DETAILS</h6>
                  </div>

                  {/* <div className="relativeWorking">
                    <h6>
                      Mark if you have any relative working in Moptra Infotech:
                    </h6>
                    <div className="checkbox-wrapper-25">
                      <input
                        id="moptraRelative"
                        type="checkbox"
                        checked={watch("moptraRelative") === "yes"}
                        onChange={(e) =>
                          setValue("moptraRelative", e.target.checked ? "yes" : "no")
                        }
                      />
                    </div>
                    {errors.moptraRelative && (
                      <p className="errorMessage">
                        {errors.moptraRelative.message}
                      </p>
                    )}
                  </div> */}

                  {moptraRelative === "yes" && (
                    <div className="table-responsive">
                      <table className="table relative-table tableWidth table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" className="tableHead">
                              Name
                            </th>
                            <th scope="col" className="tableHead">
                              Relationship
                            </th>
                            <th scope="col" className="tableHead">
                              Department
                            </th>
                            <th scope="col" className="tableHead">
                              Designation
                            </th>
                            <th scope="col" className="tableHead">
                              Employee ID
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="tableBody">
                              <input
                                className={`form-control ${errors["moptraRelativeName"] ? "invalid" : ""}`}
                                placeholder={errors["moptraRelativeName"] ? "⚠ Required" : ""}
                                {...register("moptraRelativeName", {
                                  required: true,
                                  maxLength: { value: 50, message: "Max 50 chars" },
                                  pattern: {
                                    value: /^[A-Za-z ]+$/,
                                    message: "Only letters allowed",
                                  },
                                })}
                              />
                              {errors.moptraRelativeName && (
                                <div className="errorMessage">
                                  {errors.moptraRelativeName.message}
                                </div>
                              )}
                            </td>
                            <td className="tableBody">
                              <input
                                className={`form-control ${errors["moptraRelativeRelationship"] ? "invalid" : ""}`}
                                placeholder={errors["moptraRelativeRelationship"] ? "⚠ Required" : ""}
                                {...register("moptraRelativeRelationship", {
                                  required: true,
                                  maxLength: { value: 50, message: "Max 50 chars" },
                                  pattern: {
                                    value: /^[A-Za-z ]+$/,
                                    message: "Only letters allowed",
                                  },
                                })}
                              />
                              {errors.moptraRelativeRelationship && (
                                <div className="errorMessage">
                                  {errors.moptraRelativeRelationship.message}
                                </div>
                              )}
                            </td>
                            <td className="tableBody">
                              <input
                                className={`form-control ${errors["moptraRelativeDept"] ? "invalid" : ""}`}
                                placeholder={errors["moptraRelativeDept"] ? "⚠ Required" : ""}
                                {...register("moptraRelativeDept", {
                                  required: true,
                                  maxLength: { value: 50, message: "Max 50 chars" },
                                  pattern: {
                                    value: /^[A-Za-z ]+$/,
                                    message: "Only letters allowed",
                                  },
                                })}
                              />
                              {errors.moptraRelativeDept && (
                                <div className="errorMessage">
                                  {errors.moptraRelativeDept.message}
                                </div>
                              )}
                            </td>
                            <td className="tableBody">
                              <input
                                className={`form-control ${errors["moptraRelativeDesg"] ? "invalid" : ""}`}
                                placeholder={errors["moptraRelativeDesg"] ? "⚠ Required" : ""}
                                {...register("moptraRelativeDesg", {
                                  required: true,
                                  maxLength: { value: 50, message: "Max 50 chars" },
                                  pattern: {
                                    value: /^[A-Za-z ]+$/,
                                    message: "Only letters allowed",
                                  },
                                })}
                              />
                              {errors.moptraRelativeDesg && (
                                <div className="errorMessage">
                                  {errors.moptraRelativeDesg.message}
                                </div>
                              )}
                            </td>
                            <td className="tableBody">
                              <input
                                className={`form-control ${errors["moptraRelativeEmpId"] ? "invalid" : ""}`}
                                placeholder={errors["moptraRelativeEmpId"] ? "⚠ Required" : ""}
                                {...register("moptraRelativeEmpId", {
                                  required: true,
                                  maxLength: { value: 20, message: "Max 20 chars" },
                                  pattern: {
                                    value: /^[A-Za-z0-9]+$/,
                                    message: "Only letters and numbers allowed",
                                  },
                                })}
                              />
                              {errors.moptraRelativeEmpId && (
                                <div className="errorMessage">
                                  {errors.moptraRelativeEmpId.message}
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="illnessDetailContainer">
                    <div className="illness-input-box">
                      <label>
                        Have you suffered from any major illness or surgery in last 3 years?
                      </label>
                      <div className="checkbox-wrapper-25">
                        <input
                          id="illness"
                          type="checkbox"
                          checked={watch("illness") === "yes"}
                          onChange={(e) =>
                            setValue("illness", e.target.checked ? "yes" : "no")
                          }
                        />
                      </div>
                      {errors.illness && (
                        <p className="errorMessage">
                          {errors.illness.message}
                        </p>
                      )}
                    </div>

                    {illness === "yes" && (
                      <div className="form-group col-md-12 d-flex p-0">
                        <div className="col-md-8 pl-0">
                          <textarea
                            rows={5}
                            className={`form-control  ${errors.anyIllnessDetail ? "border-red-500" : ""
                              }`}
                            {...register("anyIllnessDetail", {
                              required: "Illness details are required",
                            })}
                          />
                          {errors.anyIllnessDetail && (
                            <p className="errorMessage">
                              {errors.anyIllnessDetail.message}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4 pr-0">
                          <div className="form-group flex items-center gap-2 text-left">
                            <span>
                              Attach document{" "}
                            </span>
                          </div>
                          <input
                            type="file"
                            className={`form-control ${errors.illnessFile ? "border-red-500" : ""}`}
                            {...register("illnessFile", {
                              onChange: (e) =>
                                handleIllnessFileChange(e, "illnessDocument"),
                            })}
                          />
                          <small className="help-text text-left">(Format: PDF, PNG, JPG, or JPEG | Size: 5MB)</small>
                          {doc?.illnessDocument && (
                            <a
                              href={doc?.illnessDocument}
                              target="_blank"
                              rel="noreferrer"
                              className="ml-2 view-file"
                            >
                              <span>View 📄</span>
                            </a>
                          )}
                          {isSubmitted && docError.illnessError && (
                            <p className="errorMessage">Illness file is required</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="illnessDetailContainer">
                    <label htmlFor="hobbies" className="text-left">
                      Add Your hobbies, interests and professional
                      memberships:
                    </label>
                    <textarea id="hobbies" rows={5} {...register("hobbies")} />
                  </div>
                  <div className="declareSaveButtons">
                    <button type="button" className="backBtn" onClick={() => dispatch(goBack())} >
                      Back
                    </button>
                    <button type="button" className="saveBtn" onClick={handleSaveAsDraft} >
                      Save as draft
                    </button>
                    <button type="submit" className="saveNextBtn">
                      Save and next
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}